import React from 'react';
import { useSelector } from 'react-redux';

import { COMMENTS_BREAKPOINT } from 'constants/breakpoints';
import { CREATION_METHOD_COMMENT_OVERLAY } from 'constants/comments';
import { secondsToVideoTS } from 'utilities/time';

import useMedia from 'hooks/useMedia';

import CommentInputGroup from '../../../../comment-input-group';

const AddComment = () => {
  const currentTime = useSelector(state => state.video_player.current_time);
  const actionText = `Comment at ${secondsToVideoTS(Math.round(currentTime))}`;

  const fullSize = useMedia(
    [`(min-width: ${COMMENTS_BREAKPOINT}px)`],
    [true],
    false
  );

  return (
    <CommentInputGroup
      creationMethod={CREATION_METHOD_COMMENT_OVERLAY}
      expandOnEntry={true}
      inputSize={fullSize ? 'medium' : 'small'}
      hideNameIfPresent={true}
      placeholder={actionText}
      submitButtonText={actionText}
    />
  );
};

export default AddComment;
